export const appBackgroundColor = '#EFF1F2';
export const appFontColor = 'rgb(81, 81, 81)';

export const whiteColor = '#FFFFFF';
export const whiteHoverColor = '#FAFAFA';
export const whiteActiveColor = '#F1F1F1';

export const primaryColor = '#0059B8';
export const primaryHoverColor = '#0068D7';
export const primaryActiveColor = '#064F9D';

export const secondaryColor = '#DA375F';
export const secondaryHoverColor = '#ED3965';
export const secondaryActiveColor = '#C62C52';

export const inputBackgroundColor = '#FAFBFC';
export const inputBackgroundHoverColor = '#EBECF0';
export const inputBorderColor = '#DEE0E8';

export const appHeaderColor = 'rgb(23,51,91)';
